import { render, staticRenderFns } from "./FornecedoresForm.vue?vue&type=template&id=4759359a"
import script from "./FornecedoresForm.vue?vue&type=script&lang=js"
export * from "./FornecedoresForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports